const LOCAL_STORAGE_KEYS = {
    CART_LIST_ITEMS: 'cartListItems',
    ITEMS_LIST: 'itemsList',
};

export {LOCAL_STORAGE_KEYS};
